import React from 'react';
import PropTypes from 'prop-types';
import clsx from '@strava/ui/clsx';
import StravaLogo from '@strava/ui/StravaLogo';
import { useLoggedOutAthletePageContext } from '../../state/LoggedOutAthletePageContext';
import { getProfileVisibility } from '../../helpers/getProfileVisibility';
import styles from './Header.module.scss';

const Header = ({ className }) => {
  const { state, t, track } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { athlete } = athleteData;

  const handleTrack = () => {
    track({
      action: 'click',
      element: 'login_header',
      properties: {
        profile_visibility: getProfileVisibility(athlete)
      }
    });
  };

  return (
    <header className={clsx(styles.header, className)}>
      <StravaLogo alt="Strava" width={90} height={18} />
      <a className={styles.btnLogin} href="/login" onClick={handleTrack}>
        {t('login')}
      </a>
    </header>
  );
};

Header.defaultProps = {
  className: null
};

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
